import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/images/404.png'


const _hoisted_1 = { class: "pagenotfoiund" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Sorry!!! Currently the page you are looking for is not exist in our system.", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "oops" }, "OOPS!! Page Not Found", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Back To Home")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HomeOutlined = _resolveComponent("HomeOutlined")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createVNode(_component_a_button, { type: "primary" }, {
      default: _withCtx(() => [
        _createVNode(_component_router_link, { to: "/login" }, {
          default: _withCtx(() => [
            _createVNode(_component_HomeOutlined),
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}